import _classCallCheck from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";

function _createSuper2(Derived) {
  function isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;

    try {
      Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
      return true;
    } catch (e) {
      return false;
    }
  }

  return function () {
    var Super = _getPrototypeOf(Derived),
        result;

    if (isNativeReflectConstruct()) {
      var NewTarget = _getPrototypeOf(this).constructor;

      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return _possibleConstructorReturn(this, result);
  };
}

import { Children, cloneElement } from 'react';
import classnames from 'classnames';
import { PureComponent } from '../component';
import { cardClass } from './styles';
import { isRTL } from '../config';

var getChildId = function getChildId(child, i) {
  if (child && child.props && child.props.id !== undefined) return child.props.id;
  return i;
};

var Accordion =
/*#__PURE__*/
function (_PureComponent) {
  _inherits(Accordion, _PureComponent);

  var _super = _createSuper2(Accordion);

  function Accordion(props) {
    var _this;

    _classCallCheck(this, Accordion);

    _this = _super.call(this, props);
    _this.state = {
      active: props.active || props.defaultActive
    };
    return _this;
  }

  _createClass(Accordion, [{
    key: "getActive",
    value: function getActive() {
      if (this.props.active !== undefined) return this.props.active;
      return this.state.active;
    }
  }, {
    key: "handleActive",
    value: function handleActive(active) {
      if (active === this.state.active) active = null;
      this.setState({
        active: active
      });
      if (this.props.onChange) this.props.onChange(active);
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var active = this.getActive();
      return Children.toArray(this.props.children).map(function (child, i) {
        var childId = getChildId(child, i);
        var props = {
          collapsed: active !== childId,
          collapsible: true,
          className: classnames(typeof child === 'object' && child.className, cardClass('accordion', isRTL() && 'accordion-rtl')),
          onCollapse: _this2.handleActive.bind(_this2, childId)
        };
        return (
          /*#__PURE__*/
          cloneElement(child, props)
        );
      });
    }
  }]);

  return Accordion;
}(PureComponent);

Accordion.defaultProps = {
  defaultActive: 0
};
export default Accordion;